import React, { useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import styles from './PaginationStyles/Pagination.module.scss'
import { useNavigate, useLocation } from 'react-router-dom';

interface paginationDataType {
  itemsPerPage: number
  dataLength: number
  setItemOffset: (itemOffset: number) => void
  currentPage: any
  setCurrentPage: (currentPage: number) => void
  pageCount: number
}
const PaginationComponent = ({
  itemsPerPage,
  dataLength,
  setItemOffset,
  // currentPage,
  setCurrentPage,
  pageCount,
}: paginationDataType) => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const currentPage = parseInt(searchParams.get('page') || '1', 10);

  const handlePageClick = (event: any) => {
    setCurrentPage(event.selected + 1)
    const selectedPage = event.selected + 1;
    const newOffset = event.selected * itemsPerPage;
    setItemOffset(newOffset);
    searchParams.set('page', selectedPage.toString());
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };
  useEffect(()=>{
    setCurrentPage(currentPage)
    setItemOffset((currentPage-1) * itemsPerPage);
  },[currentPage])

  return (
    <div className={`card card-body ${styles.pagination_maincontainer}`}>
      <ReactPaginate
        breakLabel='...'
        nextLabel='Next>'
        onPageChange={handlePageClick}
        forcePage={currentPage - 1}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel='<Previous'
        renderOnZeroPageCount={null}
        containerClassName={styles.pagination_container}
        pageClassName={styles.page_num}
        nextLinkClassName={styles.page_nav_link}
        previousLinkClassName={styles.page_nav_link}
        activeClassName={styles.active}
        disabledLinkClassName={styles.disabled}
      />
    </div>
  )
}

export default PaginationComponent
